import styled from "styled-components";
import colors from "../../../../../config/colors";
import fonts from "../../../../../config/fonts";
import { isMobile } from "../../../../../utils/common";

export const StockSelectorContainer = styled.div`
  padding: 20px;
  box-sizing: border-box;
  background-color:${colors.background}cc;
  border-top:solid 1px ${colors.primary};
  border-bottom:solid 1px ${colors.primary};
  width: calc(100vw - 50px);
  height: 50px;
  display: flex;
  align-items: center;
  flex-direction: row;
  z-index: 5;
  ${isMobile() &&
  `
    width:100vw;
    position:fixed;
    top:0;
    left:0;
    justify-content:center;
  `};
`;

export const SearchResults = styled.div`
  border: solid 1px #ddd;
  position:fixed;
  top:50px;
  left:50px;
  background-color: ${colors.background};
  opacity: ${(props) => (props.hideSuggestions ? 0.5 : 1)};
  display: ${(props) => (props.hideSuggestions ? "none" : "block")};
  z-index:10;
  :hover {
    cursor: pointer;
  }
  border-radius: 10px;
  ${isMobile() &&
    `
      left:0;
    `}
`;
export const SearchResult = styled.div`
  padding: 10px 20px;
  min-width: 450px;
  box-sizing: border-box;
  transition: all 0.2s;
  background-clip: inherit;
  color: ${colors.darkPrimary};
  :hover {
    cursor: pointer;
    background-color: ${colors.primary}dd;
    color: ${colors.background};
  }
  :active {
    background-color: ${colors.primary}ff;
    color: ${colors.background};
  }
  user-select: none;
  display:flex;
  align-items:center;
  ${isMobile() &&
    `
      min-width:100vw ;
    `}
`;
export const NASDAQ = styled.div`
  font-weight:bold;
  font-size:10px;
  margin-right:10px;
  color:${colors.background};
  padding: 2px 5px;
  border-radius:5px;
  background-color:${colors.secondary};

`;
export const StockName = styled.div`
`;

export const StockHeading = styled.div`
  font-size:24px;
  ${fonts.headings};
  font-weight:bold;
  display:flex;
  align-items:center;
`;

export const EditStock = styled.svg`
  margin-left:10px;
  cursor:pointer;
  opacity:0.9;
  :hover{
    opacity:1;
  }
`;

export const EditModeElements = styled.div`
  display:flex;
  align-items:center;
`;
export const CloseEditMode = styled.img`
  height:30px;
  width:30px;
  margin-left:10px;
  cursor:pointer;
  opacity:0.9;
  :hover{
    opacity:1;
  }
`;